/**
 * Civil-date helpers shared across the app. The range presets live in one place,
 * `@/features/virtualAccount/downloadRange` (TMMAPP-0115 A1: one range vocabulary everywhere); the
 * retired `default` / `thisMonth` / `last3` / `last12` window is gone.
 */

/** The `from` / `to` query a request carries. */
export interface WindowDates {
  from?: string | undefined;
  to?: string | undefined;
}

/** A local-calendar `Date` as `YYYY-MM-DD` (never UTC — it reads the local year / month / day). */
export function toCivil(date: Date): string {
  const y = String(date.getFullYear()).padStart(4, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
